import React from 'react';
import classNames from "classnames";
import PropTypes from "prop-types";

import withStyles from "@material-ui/core/styles/withStyles";
import ProgressBarStyle from "./ProgressBarStyle";
import { CircularProgress, LinearProgress } from '@material-ui/core';

function ProgressBar({ ...props }) {
    const { classes, className, showProgressBar, type } = props;

    const progressbarContainerClass = classNames({
        [classes.progressbarContianer]: true,
        [className || '']: className
    });

    return (
        <div className={progressbarContainerClass}>
            {
                // An empty div is used to prevent noticeable changes on the ui when the progressbar disppears
                showProgressBar ?
                    (
                        type === 'circular'
                            ? <CircularProgress />
                            : <LinearProgress className={classes.progressbar} />
                    ) :
                    <div className={classes.emptyDiv} />
            }
        </div>
    );
};

ProgressBar.propTypes = {
    classes: PropTypes.object.isRequired,
    className: PropTypes.string,
    showProgressBar: PropTypes.bool,
    type: PropTypes.oneOf(["linear", "circular"]),
};

export default withStyles(ProgressBarStyle)(ProgressBar);